module.exports = __webpack_public_path__ + "media/images/allcare-app-757754a57983c138c05ea16850efba89.webp";